export const PAYMENT_DEADLINE = Object.freeze([
  { value: 4, days: 50, mu: "days", text: "50" },
  { value: 1, days: 45, mu: "days", text: "45" },
  { value: 2, days: 30, mu: "days", text: "30" },
  { value: 3, days: 15, mu: "days", text: "15" },
]);

export const TRUCK_COATING = Object.freeze({
  PRELATA: { value: 1, text: "Prelata" },
  CAROSAT: { value: 2, text: "Carosat" },
  BOTH: { value: 3, text: "Prelata & Carosat" },
});

export const TRUCK_TRANSPORT_TYPE = Object.freeze({
  GRUPAJ: { value: 1, text: "Grupaj" },
  EXPRES: { value: 2, text: "Expres" },
});

export const TRUCK_SPECIAL_FEATURE = Object.freeze({
  LIFT: { value: 1, text: "Lift hidraulic" }, 
  ADR: { value: 2, text: "ADR" },
  FRIDGE: { value: 3, text: "Frig" },
  MEGA: { value: 4, text: "Mega" },
  TERMO: { value: 5, text: "Termo" },
  CUSTOMS: { value: 6, text: "Cu vamă" },
  PALLET_EXCHANGE: { value: 7, text: "Paleți la schimb" },
});

export const TRUCK_TYPE = Object.freeze({
  SPRINTER: { value: 1, text: "Sprinter", capacity: null, mu: "ton" },
  CAMION_7_5T: { value: 2, text: "Camion 7.5t", capacity: 7.5, mu: "ton" },
  CAMION_12T: { value: 3, text: "Camion 12t", capacity: 12, mu: "ton" },
  CAMION_24T: { value: 4, text: "Camion 24t", capacity: 24, mu: "ton" },
  TRAILER: { value: 5, text: "Trailer", capacity: null, mu: "ton" },
});

export const PLATFORM_TYPE = Object.freeze({
  SEMIREMORCA: { value: 1, text: "Semiremorcă" },
  CAMION: { value: 2, text: "Camion" },
  FURGON: { value: 3, text: "Furgon" },
  AUTOTREN: { value: 4, text: "Autotren" },
  CAMION_7_5T: { value: 5, text: "Camion 7.5t" },
});
